import React from 'react'
import { cn } from './cn'

// Tailwind replacement for CoreUI's <CWidgetDropdown> stat tile. Used
// across every dashboard page (see grep for CWidgetDropdown), so this is
// worth having in the shared kit even though only WidgetsDropdown.js
// consumes it in this first migration step.
// This build's Tailwind (postcss7-compat, see migration.md) predates the
// "amber/sky/emerald/..." palette expansion — `tailwindcss/resolveConfig`
// shows only transparent/current/black/white/gray/red/yellow/green/blue/
// indigo/purple/pink are defined here. `amber`/`sky` compile to nothing
// (no error, just a class that matches no rule) rather than failing loud,
// which is how this shipped with the "warning" tile having no background
// at all. Stick to the list above for any new color here.
const COLOR_CLASSES = {
  primary: 'tw-bg-blue-600 tw-text-white',
  danger: 'tw-bg-red-600 tw-text-white',
  warning: 'tw-bg-yellow-500 tw-text-white',
  info: 'tw-bg-indigo-500 tw-text-white',
  success: 'tw-bg-green-600 tw-text-white',
  dark: 'tw-bg-gray-800 tw-text-white',
  // Light background needs dark text for contrast — everything else here
  // is a solid/bold color that reads fine with white text.
  light: 'tw-bg-gray-100 tw-text-gray-900',
}

const StatTile = ({ color = 'dark', value, label, onClick, className }) => (
  <div
    onClick={onClick}
    role={onClick ? 'button' : undefined}
    tabIndex={onClick ? 0 : undefined}
    className={cn(
      'tw-rounded tw-p-4 tw-shadow-sm',
      onClick && 'tw-cursor-pointer',
      COLOR_CLASSES[color] || COLOR_CLASSES.dark,
      className
    )}
  >
    <div className="tw-text-2xl tw-font-bold">{value}</div>
    <div className="tw-text-sm tw-opacity-90">{label}</div>
  </div>
)

export default StatTile
